import { Injectable, inject } from '@angular/core';
import { RequestService } from '@df/api/request/request.service';
import { App } from '@df/core/app';
import { CustomerModel } from '@df/session/api/customer.model';
import { DfModalService } from '@df/ui/modal/df-modal.service';
import { NBasketCarryOverModal } from './basket-carry-over-modal.component';

@Injectable()
export class BasketCarryOverService {
    private requestService = inject(RequestService);
    private app = inject(App);
    private dfModalService = inject(DfModalService);
    private customer = inject(CustomerModel);

    constructor(app: App) {
        if (app.isPlatformBrowser) {
            this.carryBasket();
        }
    }

    private carryBasket(): void {
        const retrievedObject = JSON.parse(sessionStorage.getItem('basket-carry-over'));
        if (retrievedObject) {
            const targetDate = new Date(retrievedObject.expirationDate);
            const currentDate = new Date();
            if (
                targetDate > currentDate &&
                (retrievedObject.targetSiteId.siteId === this.app.multisite.siteId ||
                    retrievedObject.targetSiteId === this.app.multisite.siteId)
            ) {
                this.requestService
                    .send(undefined, { path: 'basket/changeStore', data: { quote_id: retrievedObject?.quote_id } })
                    .then(el => {
                        if (el.disabledProducts.length) {
                            this.dfModalService.open(undefined, NBasketCarryOverModal.blockId, undefined, { variant: 'cannotCarry' });
                        }
                        sessionStorage.removeItem('basket-carry-over');
                    })
                    .catch(err => {
                        this.dfModalService.open(undefined, NBasketCarryOverModal.blockId, undefined, {
                            variant: 'error',
                            errorMessage: err.error
                        });
                        sessionStorage.removeItem('basket-carry-over');
                    });
            }
        }
    }
}
